"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERROR_TYPE_DEFAULT = exports.ERROR_TYPE_EXTENSION = exports.ERROR_TYPE_SIZE = void 0;
const ERROR_TYPE_SIZE = 'size';
exports.ERROR_TYPE_SIZE = ERROR_TYPE_SIZE;
const ERROR_TYPE_EXTENSION = 'extension';
exports.ERROR_TYPE_EXTENSION = ERROR_TYPE_EXTENSION;
const ERROR_TYPE_DEFAULT = 'default';
exports.ERROR_TYPE_DEFAULT = ERROR_TYPE_DEFAULT;
//# sourceMappingURL=errors.js.map